import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import { useAppSelector } from '../../redux/hooks'
import { GenericSpinner } from '../GenericSpinner/GenericSpinner'

export const NoAuthRoute = () => {

  const navigate = useNavigate()
  const auth = useAppSelector(state => state.auth)

  useEffect(() => {
    if (auth.data) {
      navigate('/')
    }
  }, [auth, navigate])

  if (auth.pending) {
    return <GenericSpinner />
  }

  if (auth.data) {
    return null
  }

  return <Outlet />
}